module.exports = __webpack_public_path__ + "img/box.0bd80f29.png";